import axios, {
  AxiosError,
  AxiosResponse,
  InternalAxiosRequestConfig,
} from 'axios'

import { getAuthority } from '../contexts/auth'
import { getClientId } from './authUtils'

interface TokenData {
  access_token: string
}

const { VITE_COMPANION_API_BASE_URL: COMPANION_API_BASE_URL } = import.meta.env

const apiBase = axios.create({
  baseURL: COMPANION_API_BASE_URL as string,
  headers: { 'Content-Type': 'application/json' },
})

apiBase.interceptors.request.use(
  (config: InternalAxiosRequestConfig) => {
    const LSKey = `oidc.user:${getAuthority()}:${getClientId()}`
    const tokenData = localStorage.getItem(LSKey) || ''
    config.headers = config.headers || {}
    if (tokenData) {
      config.headers.Authorization = `Bearer ${
        (JSON.parse(tokenData) as TokenData).access_token
      }`
    }
    return config
  },
  (error: AxiosError) => Promise.reject(error),
)

apiBase.interceptors.response.use(
  (response: AxiosResponse) => response,
  (error: AxiosError) => {
    if (error.response) {
      console.error(
        'Request error:',
        error.response.status,
        error.response.data,
      )
    } else if (error.request) {
      console.error('No response from server:', error.request)
    } else {
      console.error('Request configuration error:', error.message)
    }
    return Promise.reject(error)
  },
)

export default apiBase
